import(/* webpackMode: "eager", webpackExports: ["ForumIndex"] */ "/var/www/light_of_empire_front/widgets/ForumIndex/ForumIndex.tsx");
